<template>
  <div class="ap-model-search clearfix">
    <div class="float-left char-index" style="width:26px;">
      <ul class="ap-list">
        <li class="side-focus" @click="brandChar = '-1'">
          <p style="margin:0">主</p>
          <p style="margin:0">流</p>
          <p style="margin:0">厂</p>
          <p style="margin:0">牌</p>
        </li>
        <li v-for="(it,idx) in chars" :key="idx" :class="{'side-focus': brandChar == it}">
          <a class="text-center" @click="brandChar = it">{{it}}</a>
        </li>
      </ul>
    </div>
    <div style="margin-left:26px">
      <table class="table table-bordered">
        <thead>
          <tr>
            <td rowspan="2" style="width:276px">
              <p class="tit">汽车厂牌</p>
              <div>
                <SearchField placeholder="汽车厂牌名称，关键词" :small="true" :value.sync="nameLike"></SearchField>
              </div>
            </td>
            <td rowspan="2" style="width:370px">
              <p class="tit">车型</p>
              <div class="clearfix">
                <div class="float-left">
                  <select class="form-control form-control-sm" v-model="modelYear">
                    <option value>年份</option>
                    <option v-for="it in yearsList" :value="it" :key="it">{{it}}</option>
                  </select>
                </div>
                <div class="float-left" style="margin-left: 10px">
                  <SearchField placeholder="车型名称" :small="true" :value.sync="modelNameLike"></SearchField>
                </div>
              </div>
            </td>
            <td colspan="4">车款</td>
          </tr>
          <tr>
            <td></td>
            <td class="font12" style="width:52px;color:#999">功率</td>
            <td class="font12" style="width:52px;color:#999">马力</td>
            <td class="font12" style="width:52px;color:#999">排量</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td v-loading="loadingBrand" style="width:218px">
              <div class="brand-wrap">
                <div class="clearfix brand-item" v-for="it in brands" :key="it.sourceId">
                  <div class="float-left">
                    <div class="img-wrap">
                      <img class="img" v-if="it.logoUri" v-lazy="getImgUrl(it.logoUri)" />
                      <img class="img no-img" v-else src="@assets/images/no_image.png" />
                    </div>
                  </div>
                  <div style="margin-left:55px">
                    <a class="text-truncate" :class="it.rdmsId==activeBrandId?'active':''" @click="getModel(it)">{{it.name}}</a>
                  </div>
                </div>
              </div>
            </td>
            <td v-loading="loadingModel">
              <div class="col-cont-wrap">
                <div class="model-item clearfix" v-for="it in models" :key="it.sourceId">
                  <a class="clearfix" :class="it.sourceId==activeModelId?'active':''" @click="getType(it)">
                    <span class="float-right font12">{{it.years.startValue1}} - {{it.years.endValue1}}</span>
                    <span class="text-truncate">{{it.name}}</span>
                    <span v-if="it.number" class="text-truncate">({{it.number}})</span>
                  </a>
                </div>
              </div>
            </td>
            <td v-loading="loadingType" colspan="4">
              <div class="col-cont-wrap">
                <div v-for="it in types" :key="it.sourceId">
                  <a class="type-item clearfix" @click="setSearchType(it)">
                    <span class="text-truncate">{{it.name}}</span>
                    <span v-if="it.bodyType" class="text-truncate">({{it.bodyType}})</span>
                    <span class="float-right">
                      <span class="font12 text-center">{{it.years.startValue1}} - {{it.years.endValue1}}</span>
                      <span class="font12 text-center">{{it.kw}}</span>
                      <span class="font12 text-center">{{it.hp}}</span>
                      <span class="font12 text-center">{{it.ccm}}</span>
                    </span>
                  </a>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="dropdown header-nav-dropdown his-wrap">
      <div class="drop-down tit" data-toggle="dropdown" @click="getHistory">
        <img src="@assets/icons/refresh.png" />
        <span class="text">车型查询历史记录</span>
      </div>
      <div class="dropdown-arrow"></div>
      <div class="dropdown-menu" @click.stop="0">
        <ul>
          <li class="item" v-for="it in history" :key="it.id" @click.stop="goToHistory(it)">
            <span class="text" v-html="formatNum(it)"></span>
          </li>
          <li v-if="!history.length" class="clear">无历史记录！</li>
          <li v-else class="item clear" @click.stop="clearHistory">
            <i class="fas fa-trash-alt"></i>&nbsp;清空历史记录！
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import SearchField from "@components/SearchField.vue";
import * as localStorage from "@common/localStorage";

export default {
  components: {
    SearchField
  },
  data() {
    return {
      nameLike: "",
      modelYear: "",
      modelNameLike: "",
      chars: [],
      brandChar: "-1",
      brands: [],
      models: [],
      types: [],
      yearsList: [],
      activeBrandId: "",
      activeBrand: {},
      activeModelId: "",
      activeModel: {},
      showHistory: true,
      history: [],
      loadingBrand: false,
      loadingModel: false,
      loadingType: false
    };
  },
  created() {
    this.getData();
    document.title = "51 AUTOPARTS 以车型查询";
  },
  methods: {
    formatNum(x) {
      return x.brand.name + " / " + x.model.name + " / " + x.type.name;
    },
    getHistory() {
      this.history = localStorage.read("_vehicleSearchHistory") || [];
    },
    clearHistory() {
      this.history = [];
      localStorage.remove("_vehicleSearchHistory");
    },
    goToHistory(it) {
      localStorage.write("VEHICLE_SEARCH_BRAND", it.brand);
      localStorage.write("VEHICLE_SEARCH_MODEL", it.model);
      localStorage.write("VEHICLE_SEARCH_TYPE", it.type);
      window.open("#/vehiclesearch/" + it.id, "_blank");
    },
    getData() {
      this.loadingBrand = true;
      this.$list(
        "dmhs/vehBrandSels/select/",
        {},
        {
          success(res) {
            this.loadingBrand = false;
            let data = res;
            this.chars = [];
            let chars = [];
            data.forEach(it => {
              let v = it.pinYin.substring(0, 1).toUpperCase();
              if (chars.indexOf(v) == -1) {
                chars.push(v);
              }
            });
            this.chars = chars;
            this.$brands = JSON.parse(JSON.stringify(data));
            this.brands = data
              .filter(it => {
                return it.prima;
              })
              .sort((a, b) => a.seq - b.seq);
            if (!this.brands.length) {
              this.loadedText = "No data.";
            }
          }
        }
      );
      this.modelYear = "";
      this.modelNameLike = "";
    },
    getModel(it) {
      this.activeBrandId = it.rdmsId;
      this.activeBrand = it;
      this.loadingModel = true;
      this.$list(
        "dmhs/vehModels/select/",
        { brandSourceId: this.activeBrandId },
        {
          success(res) {
            this.loadingModel = false;
            let data = res;
            let years = [];
            data.forEach(it => {
              let st = it.years.startValue;
              let et = it.years.endValue;
              let stInt = null;
              let etInt = null;
              if (st) {
                st = st.substring(0, 7);
                stInt = parseInt(st.substring(0, 4));
              }
              if (et) {
                et = et.substring(0, 7);
                etInt = parseInt(et.substring(0, 4));
              }
              it.years.startValue1 = st;
              it.years.endValue1 = et;

              if (!stInt) {
                stInt = 1990;
              }
              if (!etInt) {
                etInt = new Date().getFullYear();
              }

              it.years.start = stInt;
              it.years.end = etInt;

              if (stInt && etInt) {
                let i = stInt;
                while (i <= etInt) {
                  if (years.indexOf(i) == -1) {
                    years.push(i);
                  }
                  i++;
                }
              } else {
                if (stInt) {
                  if (years.indexOf(stInt) == -1) {
                    years.push(stInt);
                  }
                }
                if (etInt) {
                  if (years.indexOf(etInt) == -1) {
                    years.push(etInt);
                  }
                }
              }
            });
            years.sort((a, b) => {
              return b - a;
            });
            this.yearsList = years;
            this.models = data;
            this.$models = JSON.parse(JSON.stringify(data));
            if (!this.models.length) {
              this.loadedText = "No data.";
            }
            this.types = [];
            this.modelYear = "";
            this.modelNameLike = "";
          }
        }
      );
    },
    getType(it) {
      this.activeModelId = it.sourceId;
      this.activeModel = it;
      this.loadingType = true;
      this.$list(
        "dmhs/vehTypes/select/",
        { modelSourceId: this.activeModelId },
        {
          success(res) {
            this.loadingType = false;
            res.forEach(it => {
              let st = it.years.startValue;
              let et = it.years.endValue;
              if (st) {
                st = st.substring(0, 7);
              }
              if (et) {
                et = et.substring(0, 7);
              }
              it.years.startValue1 = st || "";
              it.years.endValue1 = et || "";
            });
            this.types = res;
            if (!this.types.length) {
              this.loadedText = "No data.";
            }
          }
        }
      );
    },
    setSearchType(it) {
      let brand = { id: this.activeBrand.rdmsId, name: this.activeBrand.name };
      let model = {
        id: this.activeModel.sourceId,
        name: this.activeModel.name
      };
      let type = {
        id: it.sourceId,
        name: `${it.name}（${it.bodyType}） ${it.years.startValue1} - ${it.years.endValue1}`
      };
      let arr = localStorage.read("_vehicleSearchHistory") || [];
      let index = arr.findIndex(x => x.id == it.sourceId);
      if (index > -1) {
        let temp = arr.splice(index, 1);
        arr.unshift(temp[0]);
      } else {
        arr.unshift({
          id: it.sourceId,
          brand,
          model,
          type
        });
      }
      if (arr.length > 20) arr.pop();
      localStorage.write("_vehicleSearchHistory", arr);

      localStorage.write("VEHICLE_SEARCH_BRAND", brand);
      localStorage.write("VEHICLE_SEARCH_MODEL", model);
      localStorage.write("VEHICLE_SEARCH_TYPE", type);
      window.open("#/vehiclesearch/" + it.sourceId, "_blank");
    },
    filterModel() {
      let name = this.modelNameLike.toUpperCase();
      let year = this.modelYear;
      let res = this.$models;
      if (year) {
        res = res.filter(it => {
          return it.years.start <= year && year <= it.years.end;
        });
      }
      if (name) {
        res = res.filter(it => {
          return it.name.toUpperCase().indexOf(name) > -1;
        });
      }
      this.models = res;
    }
  },
  watch: {
    brandChar(v) {
      let _char = this.brandChar;
      if (_char == -1) {
        this.brands = this.$brands
          .filter(it => {
            return it.prima;
          })
          .sort((a, b) => a.seq - b.seq);
      } else {
        this.brands = this.$brands.filter(it => {
          return it.pinYin.toUpperCase().substring(0, 1) == _char;
        });
      }
      this.models = [];
      this.types = [];
    },
    nameLike(v) {
      v = v.toUpperCase();
      if (this.$timer) {
        clearTimeout(this.$timer);
      }
      let vm = this;
      this.brandChar = "";
      this.$timer = setTimeout(function() {
        vm.brands = vm.$brands.filter(it => {
          if (it.name.toUpperCase().includes(v) || it.flName.toUpperCase().includes(v)) return true;
          if (it.synonyms.filter(x => x.toUpperCase().includes(v)).length) return true;
        });
      }, 500);
      this.modelYear = "";
      this.modelNameLike = "";
    },
    modelYear(v) {
      this.filterModel();
      this.types = [];
    },
    modelNameLike(v) {
      if (this.$modelTimer) {
        clearTimeout(this.$modelTimer);
      }
      let vm = this;
      this.$modelTimer = setTimeout(function() {
        vm.filterModel();
      }, 500);
      this.types = [];
    }
  }
};
</script>

<style lang="less">
.ap-model-search {
  position: relative;
  .side-focus {
    background: #666;
    color: #fff;
  }
  .brand-wrap {
    height: 671px;
    overflow: auto;
  }
  .col-cont-wrap {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: auto;
  }
  .char-index {
    li {
      a {
        display: block;
        height: 26px;
        line-height: 24px;
        border: 1px solid #e4e4e4;
        border-bottom: none;
        border-right: none;
        font-size: 12px;
        &:hover {
          background: #666;
          color: #fff;
          border-color: #666;
        }
      }
      &:first-child {
        margin-bottom: 8px;
        font-size: 12px;
        text-align: center;
        padding: 5px 0;
        cursor: pointer;
      }
      &:last-child {
        border-bottom: 1px solid #e4e4e4;
      }
    }
  }
  .table-bordered,
  .table-bordered td,
  .table-bordered th {
    border-color: #e4e4e4;
  }
  .table {
    thead {
      background: #f6f7f9;
      .tit {
        margin-bottom: 12px;
      }
    }
    tbody td {
      position: relative;
      padding: 0;
      a {
        display: block;
        padding: 18px 0.75rem 19px;
        &:hover {
          background: #f6f7f9;
        }
      }
    }
  }
  .brand-item,
  .model-item,
  .type-item {
    border-bottom: 1px solid #e4e4e4;
  }
  .brand-item {
    .float-left {
      padding: 5px;
      border-right: 1px solid #e4e4e4;
      .img-wrap {
        width: 45px;
        height: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
        .img[lazy="loaded"] {
          width: 45px;
          height: 45px;
        }
        .img[lazy="loading"] {
          width: 35px;
          height: 35px;
        }
        .img[lazy="error"],
        .no-img {
          width: 45px;
          height: auto;
        }
      }
    }
  }
  .type-item {
    padding-right: 0 !important;
    color: #333;
    .text-center {
      padding-right: 30px;
      &:last-child {
        padding-right: 15px;
      }
    }
  }
}
</style>

<style lang="less" scoped>
.active {
  background-color: #f6f7f9 !important;
}
.his-wrap {
  position: absolute;
  right: 0;
  top: 0;
  .tit {
    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.4);
    background: #fff;
    position: absolute;
    right: 20px;
    top: -70px;
    width: 175px;
    height: 38px;
    border-radius: 19px;
    border: 1px solid #ccc;
    padding: 6px 18px;
    cursor: pointer;
    .text {
      vertical-align: middle;
      margin-left: 10px;
      font-size: 12px;
    }
  }
  .dropdown-arrow {
    left: -100px;
    top: -10px;
  }
  .dropdown-menu {
    padding: 10px;
    overflow: auto;
    left: -450px !important;
    margin: 0;
    width: 450px;
    height: 280px;
    .item {
      font-size: 12px;
      display: flex;
      padding: 4px;
      cursor: pointer;
      &:hover {
        background: #f6f7f9;
        font-weight: bold;
      }
      .text {
        color: #000;
        margin-left: 10px;
      }
    }
    .clear {
      display: block;
      text-align: center;
      padding: 8px;
    }
  }
}
</style>